// Strips undefined values so the rendered JSON-LD stays clean.
export const pruneJsonLd = <T,>(schema: T): T =>
  JSON.parse(JSON.stringify(schema, (_, v) => (v === undefined ? undefined : v)));

// Escapes only the sequence that could prematurely close the <script> tag (CMS rich
// text may contain arbitrary HTML), leaving every other character — including "<" in
// "<p>", "<a href>", etc. — untouched so the rendered payload reads like plain HTML.
const escapeScriptClose = (json: string): string =>
  json.replace(/<\/script/gi, (match) => `<\\/${match.slice(2)}`);

// Renders an XSS-safe <script type="application/ld+json"> tag for any schema.org payload.
export const JsonLdScript = ({ schema }: { schema: unknown }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: escapeScriptClose(JSON.stringify(pruneJsonLd(schema), null, 1)),
    }}
  />
);
